import { render } from "./HeadList.vue?vue&type=template&id=2d65cb39&scoped=true"
import script from "./HeadList.vue?vue&type=script&lang=js"
export * from "./HeadList.vue?vue&type=script&lang=js"

import "./HeadList.vue?vue&type=style&index=0&id=2d65cb39&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d65cb39"]])

export default __exports__